module.exports = __webpack_public_path__ + "assets/img/vtuber-2.5d.219d66b4.png";